module.exports = __webpack_public_path__ + "static/media/Niveau_elN10_4_633418.75dd870f.png";